var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.quests.length > 0)?_c('BaseActivity',{attrs:{"heading":_vm.$t('player-home:section1')}},_vm._l((_vm.quests),function(item){return _c('SwiperSlide',{key:item.title},[_c('QuestCard',_vm._b({attrs:{"imageLink":item.questLink,"buttonLink":item.puzzleLink}},'QuestCard',item,false))],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }